import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import { LanguageProvider } from './LanguageProvider';
import { ResponsiveProvider } from './ResponsiveProvider';
import { SpaContextProvider } from './SpaContextProvider';
import { ThemeProvider } from './ThemeProvider';
import * as Types from './Types';
import { UserProvider } from './UserProvider';
import { ScreenStateProvider } from './ScreenStateProvider';
import { StateFrames, WidgetProvider } from './StateFrames';
function createInitialState() {
    return {
        appState: Types.AppLoadingState.Null,
        loadingState: [],
    };
}
const AppStateContext = React.createContext(createInitialState());
AppStateContext.displayName = 'AppStateContext';
export function AppStateManager(props) {
    return (_jsx(ResponsiveProvider, { children: _jsx(ThemeProvider, { children: _jsx(Common.FrameProvider, { children: _jsx(ScreenStateProvider, { children: _jsx(UserProvider, { children: _jsx(LanguageProvider, { children: _jsx(SpaContextProvider, { children: _jsxs(WidgetProvider, { children: [_jsx(StateFrames, {}), props.children] }) }) }) }) }) }) }) }));
}
